export default __webpack_public_path__ + "static/media/education.7ff9b27e.svg";